import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';
import type { Shop } from "@/types/api/shop";

export const LookupCreateShopInputSchema = z.object({
  saleId: z.string().uuid(),
});

export type LookupCreateShopInput = z.infer<typeof LookupCreateShopInputSchema>;

export const lookupCreateShop = async ({ data }: { data: LookupCreateShopInput }): Promise<Shop> => {
  return (await api.put(`/shops`, data)).data;
};

type UseLookupCreateShopOptions = {
  mutationConfig?: MutationConfig<typeof lookupCreateShop>;
};

export const useLookupCreateShop = ({ mutationConfig }: UseLookupCreateShopOptions = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: lookupCreateShop,
  });
};
